module.exports = __webpack_public_path__ + "img/barcode.82ea98c4.svg";